module.exports = __webpack_public_path__ + "static/media/combine-harvester-garden-concept-harvesting-making-money-agriculture.4ec3f664.jpg";